import { combineReducers } from 'redux'
import user from './user.js'
import video from './video.js'

export const reducers = combineReducers({
  user,
  video,
})
